
let projectsSwiper;
var init = false;

function enableSwiper(){
	projectsSwiper = new Swiper(".home-featured-projects.load-random .swiper", {
		// Optional parameters
		loop: true,
		slidesPerView: 1,
		lazy: true,
		simulateTouch: false,

		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},

		// If we need pagination
		pagination: false,

		// Navigation arrows
		navigation: {
			nextEl: ".home-featured-projects.load-random .swiper .button-next",
			prevEl: ".home-featured-projects.load-random .swiper .button-prev",
		}
	});
}


function swiperMode() {
	let mobile = window.matchMedia("(min-width: 0px) and (max-width: 767px)");
	let tablet = window.matchMedia("(min-width: 768px) and (max-width: 1399px)");
	let desktop = window.matchMedia("(min-width: 1400px)");

	// Enable (for mobile)
	if (mobile.matches) {
		if (!init) {
			init = true;
			enableSwiper();
		}
	}

	// Disable (for tablet)
	else if (tablet.matches) {
		if(init){
			init = false;
			projectsSwiper.destroy();
		}
	}

	// Disable (for desktop)
	else if (desktop.matches) {
		if(init){
			init = false;
			projectsSwiper.destroy();
		}
	}
}

window.addEventListener("load", function () {
	swiperMode();
});

window.addEventListener("resize", function () {
	swiperMode();
});


(function ($) {
	if(typeof featuredProjects != "undefined"){

		var random_feature_projects = featuredProjects.sort(() => Math.random() - Math.random()).slice(0, 3);

		if(random_feature_projects[0]){
			$(".home-featured-projects.load-random .swiper .swiper-slide:nth-child(1)").html(random_feature_projects[0]);
		}

		if(random_feature_projects[1]){
			$(".home-featured-projects.load-random .swiper .swiper-slide:nth-child(2)").html(random_feature_projects[1]);
		}

		if(random_feature_projects[2]){
			$(".home-featured-projects.load-random .swiper .swiper-slide:nth-child(3)").html(random_feature_projects[2]);
		}
	}

})(jQuery);
